// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__F5KUv","col":"styles_col__w_QiE"};